// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"161":"42ad5543","377":"30b0e396","488":"e642c925","603":"209f2320","641":"e3182bb6","796":"50689dbf"}[chunkId] + ".css";
};